
export const styles = {
  colors: {
    lightGray: '#F4F3F7',
    grayBorder: '#E5E3E8',
    green: '#7BC73F',
    darkGray: '#54515A',
    blue: '#57C2EF',
    dark: '#393939',
    orange: '#FAAF3A',
    red: '#D03434',
  },
};
